module.exports = __webpack_public_path__ + "img/p_icon08.3e9d5892.svg";